import { FieldProps } from 'formik';
import React from 'react';
import Select from 'react-select';
import { OptionsType, ValueType } from 'react-select/src/types';

interface Option {
  label: string;
  value: string;
}

interface CustomSelectProps extends FieldProps {
  options: OptionsType<Option>;
  isMulti?: boolean;
  className?: string;
  placeholder?: string;
}

export const CustomSelect = ({
  className,
  placeholder,
  field,
  form,
  options,
  isMulti = false
}: CustomSelectProps) => {
  const onChange = (option: ValueType<Option | Option[]>) => {
    var selectedValue = undefined;

    if (isMulti) {
      if (option) {
        selectedValue = (option as Option[]).map((item: Option) => item.value);
      } else {
        selectedValue = [];
      }
    } else if (!isMulti) {
      selectedValue = (option as Option).value;
    }

    form.setFieldValue(field.name, selectedValue);
  };

  const getValue = () => {
    if (options) {
      return isMulti
        ? !field.value
          ? []
          : options.filter(option => field.value.indexOf(option.value) >= 0)
        : options.find(option => option.value === field.value);
    } else {
      return isMulti ? [] : ('' as any);
    }
  };

  return (
    <Select
      className={className}
      name={field.name}
      value={getValue()}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      isMulti={isMulti}
    />
  );
};

export default CustomSelect;
